module.exports = __webpack_public_path__ + "media/images/emblems/Rueyres-coat_of_arms-f48e5be5475d31323c6c85f215d22d1c.svg";